import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const logoDefaultVariants = {}
const logoCompoundVariants = []

const logoSlotNames = [
  [
    "root",
    "Logo__root"
  ],
  [
    "product",
    "Logo__product"
  ]
]
const logoSlotFns = /* @__PURE__ */ logoSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, logoDefaultVariants, getSlotCompoundVariant(logoCompoundVariants, slotName))])

const logoFn = memo((props = {}) => {
  return Object.fromEntries(logoSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const logoVariantKeys = []
const getVariantProps = (variants) => ({ ...logoDefaultVariants, ...compact(variants) })

export const logo = /* @__PURE__ */ Object.assign(logoFn, {
  __recipe__: false,
  __name__: 'logo',
  raw: (props) => props,
  variantKeys: logoVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, logoVariantKeys)
  },
  getVariantProps
})